import { render, staticRenderFns } from "./integral.vue?vue&type=template&id=ff67cb52&scoped=true&"
import script from "./integral.vue?vue&type=script&lang=js&"
export * from "./integral.vue?vue&type=script&lang=js&"
import style0 from "./integral.vue?vue&type=style&index=0&id=ff67cb52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff67cb52",
  null
  
)

export default component.exports